import { useState, useRef, useEffect } from "react";
import "../styles/multiSelectDropdown.css";

const SingleSelectDropdown = ({
  options = [],
  selectedValue = null,
  onChange,
  textField = "text",
  valueField = "value",
  placeholder = "Select"
}) => {

  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const isSelected = (option) =>
    selectedValue &&
    selectedValue[valueField] === option[valueField];

  const handleSelect = (option) => {
    onChange(option);
    setOpen(false);
  };

  const displayText =
    selectedValue
      ? selectedValue[textField]
      : placeholder;

  useEffect(() => {

    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);

  }, []);

  return (

    <div
      ref={ref}
      style={{ position: "relative" }}
    >

      {/* FIELD */}

      <div
        className="form-control"
        style={{
          cursor: "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
        onClick={() => setOpen(!open)}
      >
        {displayText}
        <span>▼</span>
      </div>

      {/* DROPDOWN */}

      {open && (

        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            width: "100%",
            maxHeight: "220px",
            overflowY: "auto",
            background: "#fff",
            border: "1px solid #7ec6e3"
          }}
        >

          {options.map(option => {

            const value = option[valueField];
            const text = option[textField];
            const selected = isSelected(option);

            return (

              <div
                key={value}
                className={`ms-option ${selected ? "selected" : ""}`}
                onClick={() => handleSelect(option)}
              >

                {text}

              </div>

            );

          })}

        </div>

      )}

    </div>

  );
};

export default SingleSelectDropdown;